'use client';
import { useState, useEffect } from 'react';
import { Skeleton } from 'primereact/skeleton';
import { getAuthUser } from '@/app/cart/_helpers';

export const SavedAddressList = ({ onSelect }) => {
    const user = getAuthUser();
    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user) { setLoading(false); return; }
        fetch('/api/user/address')
            .then((r) => r.json())
            .then((json) => { if (json.success) setAddresses(json.data?.addresses || json.data || []); })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    if (!user) return null;

    if (loading) {
        return (
            <div className="flex flex-column gap-2">
                <Skeleton width="8rem" height="0.75rem" />
                {[1, 2].map((i) => (
                    <Skeleton key={i} height="3.2rem" borderRadius="8px" />
                ))}
            </div>
        );
    }

    if (!addresses.length) return null;

    return (
        <div className="flex flex-column gap-2">
            <span className="text-xs font-semibold text-500 uppercase">Saved Addresses</span>
            <div style={{ maxHeight: '13rem', overflowY: 'auto'}} className="flex flex-column gap-2">
            {addresses.map((addr) => (
                <div
                    key={addr._id}
                    className="flex align-items-start gap-2 p-2 border-1 border-100 border-round-lg cursor-pointer mr-3 hover:surface-50 transition-duration-150"
                    onClick={() => onSelect(String(addr.pincode || addr.pinCode || ''))}
                >
                    <div
                        className="flex align-items-center justify-content-center border-round flex-shrink-0 mt-1"
                        style={{ width: '1.6rem', height: '1.6rem', background: 'var(--surface-200)' }}
                    >
                        <i className="pi pi-home" style={{ fontSize: '0.7rem' }} />
                    </div>
                    <div className="flex flex-column min-w-0 flex-1">
                        <div className="flex align-items-center gap-1 capitalize">
                            <span className="text-sm font-semibold text-900 overflow-hidden text-overflow-ellipsis white-space-nowrap">
                                {addr.fullName || 'Address'}
                            </span>
                            {addr.isDefault && (
                                <span className="px-1 border-round" style={{ background: '#f87171', color: 'white', fontSize: '0.65rem' }}>
                                    Default
                                </span>
                            )}
                        </div>
                        <span className="text-xs text-500 overflow-hidden text-overflow-ellipsis white-space-nowrap">
                            {[addr.city, addr.state, addr.pincode || addr.pinCode].filter(Boolean).join(', ')}
                        </span>
                    </div>
                    <i className="pi pi-arrow-right text-400 mt-1 flex-shrink-0" style={{ fontSize: '0.65rem' }} />
                </div>
            ))}
            </div>
            <div className="border-top-1 border-100 pt-1">
                <span className="text-xs text-400">or enter a different pincode below</span>
            </div>
        </div>
    );
};
